import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '../services/common/loader.service';
import { finalize } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  let loaderServ = inject(LoaderService)
  let networkCalls: string[] = [];
  let appConfigLoadingBypass: string[] = loaderServ.loadingBypass;
  let urlBypassed = false;
  appConfigLoadingBypass.forEach(e => {
    urlBypassed = req.url.includes(e)
  })
  urlBypassed ? '' : networkCalls.push(req.url);
  urlBypassed ? '' : loaderServ.start();

  return next(req).pipe(finalize(() => {
    networkCalls.indexOf(req.url) >= 0 ? networkCalls.splice(networkCalls.indexOf(req.url), 1) : '';
    setTimeout(() => {
      if (networkCalls.length == 0)
        loaderServ.stop();

    }, 500);

  }))
};
